import { render } from "./OrderFinish.vue?vue&type=template&id=507d5f82"
import script from "./OrderFinish.vue?vue&type=script&lang=js"
export * from "./OrderFinish.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__